import type { TakeoverPilotConfigEntry } from 'bundles/search-common/experiments/takeoverPilot/takeoverPilotConfig';
import {
  getCampaignConfig,
  getQueryToCampaign,
} from 'bundles/search-common/experiments/takeoverPilot/takeoverPilotConfig';
import { normalize } from 'bundles/search-common/utils/searchCards';

export type TakeoverMatch = TakeoverPilotConfigEntry;

export const getTakeoverMatchForQuery = (query: string | null | undefined): TakeoverMatch | null => {
  const normalizedQuery = normalize(query ?? undefined);

  if (!normalizedQuery) {
    return null;
  }

  const campaignId = getQueryToCampaign()[normalizedQuery];

  return campaignId ? (getCampaignConfig()[campaignId] ?? null) : null;
};

export default getTakeoverMatchForQuery;
